import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3686c73c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "text-size-14 text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "SMSによる認証コードが届かない場合", -1))

import type { PropType } from "vue";
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import Header from "@/components/organisms/common/Header.vue";
import SmsAuthForm from "@/components/organisms/auth/SmsAuthForm.vue";
import { formatPhoneNumber } from "@/utils/formatPhoneNumber";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { CreateSms } from "@/types/auth/CreateSms";
import { ValidateSms } from "@/types/auth/ValidateSms";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useModal } from "@/utils/modal";

const DEFAULT_TIMER_COUNT = 300;
const MESSAGE_ON_SMS_SENDING_ERROR =
  "SMSが送信できませんでした。時間をおいて再度お試しいただくか、音声コードによる認証をお試しください";


export default /*#__PURE__*/_defineComponent({
  __name: 'SmsAuthWithPhoneSwitch',
  props: {
  title: {
    type: String,
    required: true
  },
  phoneNumber: {
    type: String,
    default: null
  },
  createSms: {
    type: Function as PropType<CreateSms>,
    required: true
  },
  validateSms: {
    type: Function as PropType<ValidateSms>,
    required: true
  }
},
  emits: ["validated", "switchToVoice"],
  setup(__props, { emit }) {

const props = __props;




const router = useRouter();
const modal = useModal();
const loading = ref(false);

const latestPin = ref("");
const smsTimerCount = ref(0);

const phoneNumberWithHyphen = computed(() => {
  return formatPhoneNumber(props.phoneNumber);
});

const sendSms = () => {
  if (!props.phoneNumber) throw new Error();
  const body = {
    phoneNumber: props.phoneNumber
  };
  return props.createSms(body);
};

const smsValidation = (pin: string) => {
  if (!props.phoneNumber) throw new Error();
  const body = {
    latestPin: pin,
    phoneNumber: props.phoneNumber
  };
  return props.validateSms(body);
};

const setSmsTimer = () => {
  smsTimerCount.value = DEFAULT_TIMER_COUNT;
  const timer = setInterval(() => {
    if (smsTimerCount.value === 0) {
      clearInterval(timer);
      return;
    }
    smsTimerCount.value--;
  }, 1000);
};

const onClickResendSms = async () => {
  if (smsTimerCount.value !== 0) return;

  try {
    loading.value = true;
    await sendSms();
    setSmsTimer();
  } catch {
    await modal.msgBoxOk(MESSAGE_ON_SMS_SENDING_ERROR, {
      centered: true
    });
  } finally {
    loading.value = false;
  }
};

const onInputValidateSmsAndTransition = async (pin: string) => {
  if (pin === null) return;
  if (pin.length !== 4) return;

  try {
    loading.value = true;
    const { isVerified, smsSessionId } = await smsValidation(pin);
    if (!isVerified) return;
    emit("validated", smsSessionId);
  } catch {
    await modal.msgBoxOk("コードが正しくありません", {
      centered: true
    });
    latestPin.value = "";
  } finally {
    loading.value = false;
  }
};

const onClickSwitchVoiceCall = async (): Promise<void> => {
  const result = await modal.msgBoxConfirm(
    `自動の音声ガイダンスが流れ、4桁の数字を読み上げますので、お手元にメモをご用意の上、以下のボタンを押してください`,
    {
      bodyClass: "text-primary-dark",
      okTitle: "電話を受ける",
      cancelTitle: "キャンセル",
      cancelVariant: "gray-03",
      centered: true
    }
  );

  if (result) {
    emit("switchToVoice");
  }
};

onMounted(async () => {
  try {
    loading.value = true;
    await sendSms();
    setSmsTimer();
  } catch {
    await modal.msgBoxOk(MESSAGE_ON_SMS_SENDING_ERROR, {
      centered: true
    });
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(__props.title), 1)
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(phoneNumberWithHyphen.value), 1),
        _createTextVNode("に"),
        _hoisted_3,
        _createTextVNode("\n        送信された4桁の認証コードを"),
        _hoisted_4,
        _createTextVNode("\n        入力しましょう\n      ")
      ]),
      _createTextVNode(),
      _createVNode(SmsAuthForm, {
        modelValue: latestPin.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((latestPin).value = $event)),
        onInput: onInputValidateSmsAndTransition
      }, null, 8, ["modelValue"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-primary-dark': smsTimerCount.value === 0 }),
          onClick: onClickResendSms
        }, "\n          認証コードを再送信（" + _toDisplayString(smsTimerCount.value) + "秒）\n        ", 3)
      ]),
      _createTextVNode(),
      _createElementVNode("div", { class: "text-size-14 text-center" }, [
        _hoisted_6,
        _createTextVNode(),
        _createElementVNode("span", {
          class: "link",
          onClick: onClickSwitchVoiceCall
        }, "\n          音声通話により認証コードを取得する\n        ")
      ])
    ]),
    _createTextVNode(),
    _createVNode(BlockBack)
  ]))
}
}

})